import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import DataTable from "../table/DataTable";
import CashierDetailsModal from "./CashierDetailsModal";
import { cashierMockData } from "./mockData";

const CashierManagementList = () => {
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedCashier, setSelectedCashier] = useState(null);

  const columns = [
    { label: "ID", key: "id", className: "ps-4 fw-bold", style: { width: "80px", color: "black", fontSize: "12px" } },
    {
      label: "Drawer ID",
      key: "drawerId",
      render: (item) => (
        <span className="text-black fs-13">{item.drawerId}</span>
      ),
    },
    {
      label: "Branch",
      key: "branch",
      render: (item) => (
        <div className="d-flex flex-column">
          <span className="fw-bold text-black fs-13">{item.branchName}</span>
          <span className="text-muted" style={{ fontSize: "11px" }}>{item.branchAddress}</span>
        </div>
      ),
    },
    {
      label: "Status",
      key: "status",
      className: "text-center",
      cellClassName: "text-center",
      render: (item) => {
        let color = "#667085"; 
        let bgColor = "#F8F9FA";
        let borderColor = "#EAECF0";

        if (item.status === "Active") {
          color = "#027A48";
          bgColor = "#ECFDF3";
          borderColor = "#ABEFC6";
        } else if (item.status === "Inactive") {
          color = "#B42318";
          bgColor = "#FEF3F2";
          borderColor = "#FECDCA";
        }

        return (
          <Badge
            bg="light"
            className="px-3 py-1 border rounded"
            style={{
              fontSize: "11px",
              color: color,
              backgroundColor: bgColor,
              borderColor: borderColor,
            }}
          >
            {item.status}
          </Badge>
        );
      },
    },
    {
      label: "Created Date",
      key: "createdDate",
      render: (item) => {
        const parts = item.createdDate.split("\n");
        return (
          <div className="d-flex flex-column">
            <span className="text-black fs-13">{parts[0]}</span>
            {parts[1] && <span className="text-muted" style={{ fontSize: "11px" }}>{parts[1]}</span>}
          </div>
        );
      },
    },
    {
      label: "Actions",
      key: "actions",
      className: "text-center pe-4",
      cellClassName: "text-center pe-4",
      render: (item) => (
        <button 
          className="btn btn-xs p-0 border-0 bg-transparent text-muted"
          onClick={() => {
            setSelectedCashier(item);
            setShowViewModal(true);
          }}
        >
          <i className="far fa-eye fs-14"></i>
        </button>
      ),
    },
  ];

  return (
    <div className="container-fluid" style={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
      <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 gap-2 pt-2">
        <h2 className="fw-bold text-black mb-0 fs-24">Cashier Management</h2>
      </div>

      <div className="card border-0 rounded-4 overflow-hidden" style={{ boxShadow: "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)" }}>
        <DataTable
          columns={columns}
          data={cashierMockData}
          showPagination={false}
          minWidth="100%"
        />
      </div>

      <CashierDetailsModal 
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        cashier={selectedCashier}
      />
    </div>
  );
};

export default CashierManagementList;
